"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FBAPrepType = void 0;
var FBAPrepType;
(function (FBAPrepType) {
    FBAPrepType["ITEM_LABELING"] = "ITEM_LABELING";
    FBAPrepType["ITEM_BUBBLEWRAP"] = "ITEM_BUBBLEWRAP";
    FBAPrepType["ITEM_POLYBAGGING"] = "ITEM_POLYBAGGING";
    FBAPrepType["ITEM_TAPING"] = "ITEM_TAPING";
    FBAPrepType["ITEM_BLACK_SHRINKWRAP"] = "ITEM_BLACK_SHRINKWRAP";
    FBAPrepType["ITEM_HANG_GARMENT"] = "ITEM_HANG_GARMENT";
    FBAPrepType["ITEM_BOXING"] = "ITEM_BOXING";
    FBAPrepType["ITEM_SETCREAT"] = "ITEM_SETCREAT";
    FBAPrepType["ITEM_RMOVHANG"] = "ITEM_RMOVHANG";
    FBAPrepType["ITEM_SUFFOSTK"] = "ITEM_SUFFOSTK";
    FBAPrepType["ITEM_CAP_SEALING"] = "ITEM_CAP_SEALING";
    FBAPrepType["ITEM_DEBUNDLE"] = "ITEM_DEBUNDLE";
    FBAPrepType["ITEM_SETSTK"] = "ITEM_SETSTK";
    FBAPrepType["ITEM_SIOC"] = "ITEM_SIOC";
    FBAPrepType["ITEM_NO_PREP"] = "ITEM_NO_PREP";
    FBAPrepType["ADULT"] = "ADULT";
    FBAPrepType["BABY"] = "BABY";
    FBAPrepType["TEXTILE"] = "TEXTILE";
    FBAPrepType["HANGER"] = "HANGER";
    FBAPrepType["FRAGILE"] = "FRAGILE";
    FBAPrepType["LIQUID"] = "LIQUID";
    FBAPrepType["SHARP"] = "SHARP";
    FBAPrepType["SMALL"] = "SMALL";
    FBAPrepType["PERFORATED"] = "PERFORATED";
    FBAPrepType["GRANULAR"] = "GRANULAR";
    FBAPrepType["SET"] = "SET";
    FBAPrepType["FC_PROVIDED"] = "FC_PROVIDED";
    FBAPrepType["UNKNOWN"] = "UNKNOWN";
    FBAPrepType["NONE"] = "NONE";
})(FBAPrepType || (exports.FBAPrepType = FBAPrepType = {}));
//# sourceMappingURL=FBAPrepType.js.map